export enum Games {
  GAMES = 'Games',
}
